/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/EmployeeManagement/index.tsx
 * PURPOSE: Employee Management page — thin wrapper mounting the generic
 *          MasterDataCrudPage framework with the Employee schema, giving
 *          Employee a full Create/Read/Update/Delete screen for free.
 * SDLC FRAMEWORK VERSION: 6.3.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * DATE: 2026-07-09
 * COMPLIANCE: SDLC 6.3.1 + BR-PLAT-001-MASTER-DATA-CRUD-IMPORT-EXPORT-STANDARD
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * @business-context
 * - Domain: Vietnamese F&B Employee Master Data
 * - Impact: BR-PLAT-001 backlog item "Build Employee CRUD frontend screen" (5 SP)
 * - Stakeholders: @cto, HR Admins, Tenant Admins
 *
 * @technical-architecture
 * - Layer: Frontend Presentation Layer
 * - Pattern: Config-Driven UI (page delegates all behavior to employeeSchema)
 * - Dependencies: frontend/src/components/master-data/MasterDataCrudPage.tsx
 *
 * @cross-references
 * - Schema: frontend/src/pages/EmployeeManagement/employeeSchema.ts
 * - Route: frontend/src/App.tsx (/tenant-admin/employees)
 * - BR: docs/01-planning/01-requirements/BR-PLAT-001-MASTER-DATA-CRUD-IMPORT-EXPORT-STANDARD.md
 */

import React from 'react';
import { MasterDataCrudPage } from '@/components/master-data/MasterDataCrudPage';
import { employeeSchema } from './employeeSchema';

export const EmployeeManagement: React.FC = () => {
  return <MasterDataCrudPage schema={employeeSchema} />;
};

export default EmployeeManagement;
